<template>
    <v-dialog v-model="dialog"  max-width="446" min-height="298">
        <v-card>
            <v-toolbar class="modal-header" :class="{'bg-reddish': headerColor=='red'}">
                <v-toolbar-title>{{ title }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="confirmation card-text-con">
                <slot></slot>
            </v-card-text>
            <v-card-actions class="justify-end" style="padding-right:17px;">
                <button @click="close" class="action-btn text-btn text-uppercase">Close</button>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { VDialog, VCard,VToolbarTitle,VToolbar, VCardText, VCardActions } from 'vuetify'

export default {
    name: 'AlertDialog',
    props:['value', 'title', 'headerColor'],
     
components : {
    VDialog, VCard, VCardText, VToolbar, VToolbarTitle, VCardActions  
},
computed: {
    dialog: {
        get() {
            return this.value;
        },
        set(value) {
            this.$emit('closed', value);
        }
    }
},
methods: {
    close() {
        this.dialog = false;
    }
    ,
}
};
</script>
<style lang="scss" scoped>
   .confirmation.card-text-con{
    padding: 23px 16px 0 16px !important;
   }
   .v-card {
    flex: 1;
   }
   .v-card-actions {
    padding-top: 18px;
    padding-bottom: 18px;
   }
   .v-toolbar__title{
    color: #333333;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 1.2;
   }
   .action-btn {
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    transition: 0.2s all ease;
    color: #2F80ED;
    &:hover {
        opacity: 0.62;
    }
   }
   .bg-reddish {
    background-color: #F0D3D3 !important;
   }
</style>